<div class="container">
<mat-accordeon >
  <app-notification *ngFor="let x of notifications" [notification]="x">
  </app-notification>

</mat-accordeon>

<h4 *ngIf="notifications && notifications.length == 0">{{"NOTIFICATIONS.NONE" | translate}}</h4>
</div>